import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { ArchidriveFilterComponent } from './archidrive-filter';

export const ArchidriveFilterModule: string = ng
    .module('archidrive-filter', [
        'ui.bootstrap',
        uiRouter
    ])
    .component('archidriveFilterComponent', ArchidriveFilterComponent)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/archidrive/archidrive-filter/archidrive-filter.module.ts